import { Linkedin } from "lucide-react";

const toSlug = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const getInitials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 3)
    .join("")
    .toUpperCase();

export const TeamMemberCard = ({ member }) => (
  <div
    data-testid={`team-member-${toSlug(member.name)}`}
    className="relative border border-white/10 bg-[#0D1220] p-8 shadow-[0_28px_60px_-32px_rgba(16,23,37,0.28)] sm:p-10"
  >
    <div
      className="absolute -right-4 -top-4 h-16 w-16 border-r border-t border-[#F26122]/40"
      aria-hidden="true"
    />
    <div className="flex flex-col items-start gap-8 sm:flex-row">
      {member.photo ? (
        <div className="relative shrink-0 overflow-hidden border border-[#F26122]/30 bg-[#0B0F17] shadow-[0_16px_40px_-20px_rgba(16,23,37,0.35)]">
          <img
            src={member.photo}
            alt={`${member.name}, ${member.designation}`}
            className="h-56 w-44 object-cover object-top sm:h-64 sm:w-52"
          />
        </div>
      ) : (
        <div
          className="relative flex h-56 w-44 shrink-0 items-center justify-center border border-[#F26122]/30 bg-[#0B0F17] sm:h-64 sm:w-52"
          aria-hidden="true"
        >
          <span className="font-display text-5xl font-light tracking-widest text-[#F26122]/70">
            {getInitials(member.name)}
          </span>
        </div>
      )}
      <div>
        <h3
          data-testid={`team-member-name-${toSlug(member.name)}`}
          className="font-display text-2xl font-light text-slate-100 sm:text-3xl"
        >
          {member.name}
        </h3>
        <p className="mt-1 font-mono2 text-xs uppercase tracking-[0.25em] text-[#F2824F]">
          {member.designation}
        </p>
        <p className="mt-5 text-sm font-light leading-relaxed text-slate-400">
          {member.bio}
        </p>
        {member.linkedin && (
          <a
            data-testid={`team-member-linkedin-${toSlug(member.name)}`}
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 border border-white/15 px-5 py-2.5 text-xs font-medium tracking-wide text-slate-300 transition-all duration-300 hover:border-[#F26122]/60 hover:text-[#F26122]"
          >
            <Linkedin className="h-3.5 w-3.5" />
            Connect on LinkedIn
          </a>
        )}
      </div>
    </div>
  </div>
);

export default TeamMemberCard;
